<script lang="ts">
  import { getISODay, getISOTime } from '#app/lib/time'
  import type { EpochTimeStamp } from '#app/types/common'
  import { I18n } from '#user/lib/i18n'
  import { mainUserHasAdminAccess } from '#user/lib/serialized_main_user'

  const {
    id,
    created,
  }: {
    id: string
    created?: EpochTimeStamp
  } = $props()
</script>

{#if mainUserHasAdminAccess()}
  <div class="admin-info">
    <span class="identifier">{id}</span>
    {#if created}
      <span class="creation-date" title={`${I18n('created')}: ${getISOTime(created)}`}>
        {getISODay(created)}
      </span>
    {/if}
  </div>
{/if}

<style lang="scss">
  @import "general/scss/utils";

  .admin-info{
    position: relative;
    margin: 0 0.5rem;
    @include identifier;
    background-color: $off-white;
    @include radius;
    padding: 0.2rem;
  }

  /* Small screens */
  @media screen and (width < $small-screen){
    .admin-info{
      display: none;
    }
  }
</style>
